import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-coldStorage-stepIcon",
  "use": "icon-coldStorage-stepIcon-usage",
  "viewBox": "0 0 15 14",
  "content": "<symbol viewBox=\"0 0 15 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-coldStorage-stepIcon\">\n<circle cx=\"7.5\" cy=\"7\" r=\"6.25\" fill=\"#DAECDA\" stroke=\"#46A147\" stroke-width=\"1.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol